"use client";

import {FCWithChildren} from "@/app/types/reactTypes";
import React from "react";
import {useUserInfo} from "../contexts/userInfoContext";

type RequireLoginProps = {
	fallback?: React.ReactElement;
	loadingFallback?: React.ReactElement;
};

const RequireLogin: FCWithChildren<RequireLoginProps> = ({
	children,
	fallback,
	loadingFallback,
}) => {
	const {isLoading, userInfo} = useUserInfo();

	if (isLoading) {
		return loadingFallback;
	}

	if (!userInfo) {
		return fallback;
	}

	return children;
};

export default RequireLogin;
